import React from "react";
import { Link } from "react-router-dom";
import { formatDate } from "../../helper/Helper";

const SortableRow = React.memo(
  ({ item, index, page, limit, handleStatusChange, openDelete }) => {
    return (
      <tr>
        <td> <b>{(page - 1) * limit + index + 1}.</b></td>

        <td>
          <div className="d-flex align-items-center">
            {item.image && (
              <a
                href={item.image}
                target="_blank"
                rel="noopener noreferrer"
                className="avatar avatar-lg me-2"
              >
                <img src={item.image} alt="img" />
              </a>
            )}
            <div>
              <h6 className="fw-bold mb-1">{item.name}</h6>
              <p className="fs-13">{item.code}</p>
            </div>
          </div>
        </td>

        <td>{item.contactPerson || ""}</td>
        <td>
          {item.mobile || ""} <br /> {item.email || ""}
        </td>
        <td>{formatDate(item.createdAt)}</td>

        <td className="action-table-data">
          <div className="edit-delete-action">
            <Link to={`/suppliers/edit/${item._id}`} className="me-2 p-2">
              <i className="ti ti-pencil" />
            </Link>

            <a
              className="p-2"
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              onClick={() => openDelete(item._id)}
            >
              <i className="ti ti-trash" />
            </a>
          </div>
        </td>
      </tr>
    );
  },
);

export default SortableRow;
